var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"picker-point",class:[_vm.pointClass,{current:_vm.picked}],style:(_vm.inlineStyle),on:{"click":function($event){return _vm.handleTimeChange(_vm.index,_vm.angle,_vm.picked)}}},[_c('div',{staticClass:"pointer-wrapper",style:(_vm.wrapperStyle)},[_vm._v(_vm._s(_vm.index))])])
}
var staticRenderFns = []

export { render, staticRenderFns }